"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var clickOutsideHook_1 = require("@common/hooks/clickOutsideHook");
function SelectDropdown(props) {
    var DEFAULT_PLACEHOLDER_TEXT = 'Please select';
    var items = props.items, selectedItemId = props.selectedItemId, placeholderText = props.placeholderText, onItemSelected = props.onItemSelected, hasError = props.hasError, className = props.className, customSuffix = props.customSuffix, onBlur = props.onBlur;
    var _a = __read((0, react_1.useState)(false), 2), menuOpened = _a[0], setMenuOpened = _a[1];
    var onMenuToggled = function (menuOpened) {
        setMenuOpened(!menuOpened);
    };
    var component = (0, react_1.useRef)(null);
    (0, clickOutsideHook_1.useClickOutside)(component, function () { return setMenuOpened(false); });
    var getButtonText = function (items, selectedItemId, placeholderText) {
        if (selectedItemId) {
            var itemMatched = items.find(function (it) { return it.id === selectedItemId; });
            if (itemMatched) {
                return customSuffix ? "".concat(itemMatched.text, " ").concat(customSuffix) : itemMatched.text;
            }
        }
        return placeholderText || DEFAULT_PLACEHOLDER_TEXT;
    };
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-select-dropdown', hasError && 'eva-select-dropdown--has-error', className), ref: component, onBlur: onBlur },
        react_1.default.createElement("div", { className: "eva-select-dropdown__selected-item", onClick: function () { return onMenuToggled(menuOpened); } },
            react_1.default.createElement("div", { className: "eva-select-dropdown__selected-item__text" }, getButtonText(items, selectedItemId, placeholderText)),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-select-dropdown__selected-item__icon', menuOpened ? 'eva-caret--up' : 'eva-caret--down') })),
        menuOpened ? (react_1.default.createElement("ul", { className: "eva-select-dropdown__menu" }, items.map(function (item) { return (react_1.default.createElement("li", { className: "eva-select-dropdown__menu__item ".concat(item.isDisabled ? 'disabled' : ''), key: item.id, onClick: function () {
                if (!item.isDisabled) {
                    setMenuOpened(false);
                    onItemSelected(item.id);
                }
            } }, item.text)); }))) : ('')));
}
exports.default = SelectDropdown;
